import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AboutHero from "../components/AboutUs/AboutHero";
import Profile from "../components/AboutUs/Profile";
import MissionVision from "../components/AboutUs/MissionVision";
import CoreValues from "../components/AboutUs/CoreValues";
import Team from "../components/AboutUs/Team";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ overflowX: "hidden", backgroundColor: "#F5F7FA" }}>
      <Navbar />
      <AboutHero />
      <Profile />
      <MissionVision />
      <CoreValues />
      <Team />
      <Footer />
    </Box>
  );
};

export default AboutUs;
